module.exports = __webpack_public_path__ + "assets/img/00150.bcd5b22f.png";